const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === 'light' ? lightTheme : darkTheme),
  },
});

export default getDesignTokens;

export const lightTheme = {
  primary: { main: 'rgba(0, 51, 153, 1)', text: 'rgba(20, 40, 90, 1)', light: 'rgb(23, 84, 255, 1)', textLight: 'rgb(137, 147, 172,1)' },
  white: { main: 'rgba(255,255,255,1)', background: 'rgba(242, 242, 243, 1)' },
  grey: { main: 'rgba(20, 40, 90, 0.25)', light: 'rgba(20, 40, 90, 0.05)', dark: 'rgba(137, 147, 172, 1)' },
  link: { main: 'rgba(0, 109, 255, 1)' },
};

export const darkTheme = {
  primary: { main: 'rgba(0, 51, 153, 1)', text: 'rgba(20, 40, 90, 1)' },
  white: { main: 'rgba(255,255,255,1)', background: 'rgba(242, 242, 243, 1)' },
  grey: { main: 'rgba(20, 40, 90, 0.25)', light: 'rgba(20, 40, 90, 0.05)', dark: 'rgba(137, 147, 172, 1)' },
  link: { main: 'rgba(0, 109, 255, 1)' },
};
